/**
 * Created by wangjianwen on 2017/10/16.
 */
import Lockr from 'lockr'
export default {
    getExamRegInfo(states){
        return states.examRegInfo;
    },
    getExamRegId(states){
        return states.examRegId;
    },
    getBatchId(states){
        return states.batchId;
    },
    getPromiseState(states){
        return states.promiseState;
    },
    getBackOrNextStep(states){
        return states.backOrNextStep;
    },
};